// extracted by mini-css-extract-plugin
module.exports = {"dotsContainer":"DotLoader_dotsContainer__gVf0H","dot":"DotLoader_dot__rGmgH","blinking":"DotLoader_blinking__n6bSO"};